export const GetCardBackground = (typeOfCard) => {
    switch (typeOfCard) {
      case 'Truth':
        return `
        radial-gradient(ellipse at center bottom, rgba(202, 59, 193, 0.44), transparent 70%),
        radial-gradient(ellipse at 50% 110%, rgba(255, 64, 0, 0.27), transparent 30%),
        radial-gradient(ellipse at 25% 110%, rgba(255, 64, 0, 0.21), transparent 20%),
        radial-gradient(ellipse at 85% 110%, rgba(255, 64, 0, 0.21), transparent 20%),
        radial-gradient(ellipse at 25% 100%, rgba(255, 0, 238, 0.24), transparent 30%),
        radial-gradient(ellipse at 85% 100%, rgba(255, 0, 238, 0.24), transparent 30%),
        linear-gradient(to bottom,rgb(32, 18, 56) 20% ,rgba(127, 41, 148, 0.63) 50% ,rgba(192, 44, 182, 0.57) 90%,rgba(229, 38, 181, 0.7))
    `;
      case 'Light Dare':
        return `
        radial-gradient(ellipse at center bottom, rgba(227, 61, 95, 0.44), transparent 70%),
        radial-gradient(ellipse at 50% 110%, rgba(255, 64, 0, 0.27), transparent 30%),
        radial-gradient(ellipse at 25% 110%, rgba(255, 64, 0, 0.21), transparent 20%),
        radial-gradient(ellipse at 85% 110%, rgba(255, 64, 0, 0.21), transparent 20%),
        radial-gradient(ellipse at 25% 100%, rgba(255, 32, 119, 0.24), transparent 40%),
        radial-gradient(ellipse at 85% 100%, rgba(255, 32, 119, 0.24), transparent 40%),
        linear-gradient(to bottom,rgb(28, 16, 50) 20% ,rgba(105, 25, 89, 0.63) 40% ,rgb(138, 22, 47) 90%,rgba(250, 50, 70, 0.7))
    `;
      case 'Dare':
        return `radial-gradient(ellipse at center bottom, rgba(255, 64, 0, 0.34), transparent 70%),
        radial-gradient(ellipse at 25% 100%, rgba(255, 64, 0, 0.24), transparent 50%),
        radial-gradient(ellipse at 85% 100%, rgba(255, 64, 0, 0.24), transparent 50%),
        radial-gradient(ellipse at 50% 110%, rgba(255, 64, 0, 0.27), transparent 30%),
        radial-gradient(ellipse at 25% 110%, rgba(255, 64, 0, 0.21), transparent 20%),
        radial-gradient(ellipse at 85% 110%, rgba(255, 64, 0, 0.21), transparent 20%),
        linear-gradient(to bottom, #1a0f2d 20% ,rgba(70, 16, 56, 0.63) 40% , #921010 90%,rgba(255, 60, 0, 0.7))
        `;
      case 'Kinky Dare':
        return `
     radial-gradient(ellipse at center bottom, rgba(255, 0, 0, 0.54), transparent 70%),
     radial-gradient(ellipse at 25% 100%, rgba(255, 0, 0, 0.52), transparent 40%),
     radial-gradient(ellipse at 95% 100%, rgba(255, 0, 0, 0.48), transparent 36%),
     linear-gradient(to bottom,rgb(21, 12, 36) 20% ,rgba(70, 16, 38, 0.63) 50% ,rgba(148, 9, 9, 0.53) 95%,rgba(255, 21, 0, 0.5))
    `;
      default:
        return `radial-gradient(ellipse at center bottom, rgba(255, 64, 0, 0.34), transparent 70%),
        radial-gradient(ellipse at 25% 100%, rgba(255, 64, 0, 0.24), transparent 50%),
        radial-gradient(ellipse at 85% 100%, rgba(255, 64, 0, 0.24), transparent 50%),
        radial-gradient(ellipse at 50% 110%, rgba(255, 64, 0, 0.27), transparent 30%),
        radial-gradient(ellipse at 25% 110%, rgba(255, 64, 0, 0.21), transparent 20%),
        radial-gradient(ellipse at 85% 110%, rgba(255, 64, 0, 0.21), transparent 20%),
        linear-gradient(to bottom, #1a0f2d 20% ,rgba(70, 16, 56, 0.63) 40% , #921010 90%,rgba(255, 60, 0, 0.7))
        `;
    }
  };
